const environmentDomain = window.location.origin;

const TEST_CONFIG = {
  VERSION: "1.0.5",
  NAME: "AKEAD-TEST",
  API_URL: "https://authenticationtest.akead.link",
  PARTNER_URL: "https://partnertest.akead.xyz",
  HELP_URL: "https://apigatetest.akead.xyz/help",
  CODE: "200",
  CHIPER_KEY: "125%44.6",
};

const PROD_CONFIG = {
  VERSION: "1.0.4",
  NAME: "AKEAD-PROD",
  API_URL: "https://authentication.akead.link",
  PARTNER_URL: "https://partner.akead.link",
  HELP_URL: "https://help.akead.link",
  CODE: "200",
  CHIPER_KEY: "125%44.6",
};

const config = () => {
  const origin = String(environmentDomain || "").toLowerCase();
  if (
    origin.includes("localhost") ||
    origin.includes("127.0.0.1") ||
    origin.includes("shoptest.akead.net")
  ) {
    return TEST_CONFIG;
  }

  if (origin.includes("shop.akead.net")) {
    return PROD_CONFIG;
  }

  console.warn(
    "Environment domain unknown, TEST_CONFIG kullanılıyor:",
    origin
  );
  return TEST_CONFIG;
};

export default config;